import { FC } from 'react'
import {
  Box,
  Text,
  Accordion,
  AccordionButton,
  AccordionPanel,
  AccordionItem,
  Flex,
  IconButton,
  useClipboard,
  Divider,
} from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'
import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons'
import { CopyIcon } from '_app/components/Icons'
import toast from '_app/utils/toast'

interface DescriptionProps {
  description?: { html: string } | null;
  short_description?: { html: string } | null;
  sku?: string | null;
}

const Description: FC<DescriptionProps> = ({
  description,
  short_description,
  sku,
}) => {
  const { t } = useTranslation('product')
  const { onCopy } = useClipboard(sku ?? '')

  return (
    <Accordion allowToggle>
      {!!description?.html && (
        <>
          <AccordionItem
            border="none"
            pb={!!short_description?.html ? '16px' : 'unset'}
          >
            {({ isExpanded }) => (
              <>
                <AccordionButton _hover={{ bg: 'white' }} p="0">
                  <Text flex="1" textAlign="left">
                    {t('DESCRIPTION')}
                  </Text>
                  <Box w="24px" h="24px">
                    {!isExpanded ? (
                      <ChevronDownIcon w="100%" h="100%" />
                    ) : (
                      <ChevronUpIcon w="100%" h="100%" />
                    )}
                  </Box>
                </AccordionButton>
                <AccordionPanel p={0} pt={4}>
                  <Box pt={4} textStyle="bodyLight">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: description.html,
                      }}
                    />
                  </Box>
                  {sku && (
                    <Flex mt={5} alignItems="center" flexWrap="wrap">
                      <Text mr={3} textStyle="bodyLight">
                        {t('PRODUCT_CODE')}:
                      </Text>
                      <Text mr={3} textStyle="bodyLight">
                        {sku}
                      </Text>
                      <IconButton
                        mr={3}
                        p={2}
                        variant="icon"
                        onClick={() => {
                          onCopy()
                          toast({
                            description: t('PRODUCT_CODE_COPIED'),
                            status: 'success',
                          })
                        }}
                        icon={<CopyIcon />}
                        aria-label={t('COPY_TO_CLIPBOARD')}
                      />
                    </Flex>
                  )}
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        </>
      )}
      {!!short_description?.html && (
        <>
          {!!description?.html && <Divider />}
          <AccordionItem
            border="none"
            pt={!!description?.html ? '16px' : 'unset'}
          >
            {({ isExpanded }) => (
              <>
                <AccordionButton _hover={{ bg: 'white' }} p="0">
                  <Text flex="1" textAlign="left">
                    {t('CARE')}
                  </Text>
                  <Box w="24px" h="24px">
                    {!isExpanded ? (
                      <ChevronDownIcon w="100%" h="100%" />
                    ) : (
                      <ChevronUpIcon w="100%" h="100%" />
                    )}
                  </Box>
                </AccordionButton>
                <AccordionPanel p={0} pt={4}>
                  <Box pt={4} textStyle="bodyLight">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: short_description.html,
                      }}
                    />
                  </Box>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        </>
      )}
    </Accordion>
  )
}

export default Description
